import useSWR from "swr";
import { EmailTemplateMetadataResponse, EmailTemplateResponse } from "../../models/EmailTemplateModels";
import { environment } from "../../config/environment";
import { useSWRFetcher } from "../useSWRFetcher";

export const useEmailTemplates = () => {
  const fetcher = useSWRFetcher();

  const { data, isLoading, error, mutate } = useSWR<EmailTemplateResponse[]>(
    `${environment.apiUrl}/api/organisation/email-templates`,
    (url: string) => fetcher(url),
    {}
  );

  const {
    data: metadata,
    isLoading: isMetadataLoading,
    error: metadataError,
  } = useSWR<EmailTemplateMetadataResponse[]>(
    `${environment.apiUrl}/api/organisation/email-templates/metadata`,
    (url: string) => fetcher(url),
    {}
  );

  return {
    emailTemplates: data,
    emailTemplatesMetadata: metadata,
    isLoading: isLoading || isMetadataLoading,
    isError: !!error || !!metadataError,
    refetchEmailTemplates: () => mutate(),
  };
};
